import { useEffect } from 'react';
import { Control, UseFormGetValues, UseFormSetValue } from 'react-hook-form';

import { IPricingForm } from 'partsOld/types';

import PricingItemView from './PricingItemView';

interface IProps {
  control: Control<IPricingForm, object>;
  getValues: UseFormGetValues<IPricingForm>;
  setValue: UseFormSetValue<IPricingForm>;
  removePrice?: (index: number) => void;
  index: number;
}

const PricingItem = ({ control, index, getValues, removePrice, setValue }: IProps) => {
  const uom = getValues('uom');

  const minQty = getValues(`priceItems.${index - 1}.maxQuantity`) || 0;

  useEffect(() => {
    if (index === 0) {
      return;
    }

    setValue(`priceItems.${index}.minQuantity`, minQty);
  }, [index]);

  return <PricingItemView uom={uom} control={control} index={index} removePrice={removePrice} />;
};

export default PricingItem;
